/* global DetectUserAgent */
import { isNil } from "ramda";
import { parse } from "query-string";

import useRouter from "./useRouter";

const useUtmsParams = () => {
  const { location } = useRouter();
  let utmsParams = null;

  if (DetectUserAgent.isAndroid()) {
    const params = location.search ? parse(location.search) : parse(location.hash);
    if (!isNil(params.state)) {
      utmsParams = params.state;
    }
  }

  return { utmsParams };
};

export default useUtmsParams;
